import { type FC } from 'react';
import { Group } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { BankIdentity } from '~/entities/bank';

interface BankCodeSelectOptionProps {
    bankCode: string;
    checked?: boolean;
}

export const BankCodeSelectOption: FC<BankCodeSelectOptionProps> = ({ bankCode, checked }) => (
    <Group
        flex={1}
        gap='xs'
        justify='space-between'
        wrap='nowrap'
    >
        <BankIdentity bankCode={bankCode} />

        {checked && <IconCheck size={16} />}
    </Group>
);
